export const IOS_APP_URL =
  "https://apps.apple.com/us/app/buddy-dive-log-community/id1588860327";
